export const getProductApprovalStatus = (product) => product?.approvalStatus || "approved";

export const getProductApprovalLabel = (status) => {
  if (status === "pending") return "Pending review";
  if (status === "rejected") return "Rejected";
  return "Approved";
};

export const getProductApprovalBadgeTone = (status) => {
  if (status === "pending") return "warning";
  if (status === "rejected") return "danger";
  return "success";
};
